import { useEffect } from "react";
import { linkTo } from "@/i18n";

export function SEO({ title, description, lang, pathKey, slug }) {
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    document.querySelectorAll("link[rel='alternate'][data-seo], link[rel='canonical'][data-seo]").forEach((e) => e.remove());
    const origin = window.location.origin;
    const mk = (rel, hreflang, href) => {
      const l = document.createElement("link");
      l.rel = rel;
      if (hreflang) l.hreflang = hreflang;
      l.href = href;
      l.dataset.seo = "1";
      document.head.appendChild(l);
    };
    if (pathKey) {
      mk("canonical", null, origin + linkTo(lang, pathKey, slug));
      mk("alternate", "it", origin + linkTo("it", pathKey, slug));
      mk("alternate", "en", origin + linkTo("en", pathKey, slug));
      mk("alternate", "x-default", origin + linkTo("it", pathKey, slug));
    }
  }, [title, description, lang, pathKey, slug]);
  return null;
}
